import { BooleanInput } from 'react-admin'
import React, { useCallback } from 'react'
import { useFormContext } from 'react-hook-form'
import { ROLES_FIELDS } from '../../../providers/localization/constant'

export const AllPermissionBooleanInput = ({ defaultValue = false }): JSX.Element => {
  const { getValues, setValue } = useFormContext()
  const toggleCheckAll = useCallback(() => {
    const permissionsRoles = getValues('permissions')
    const allPermission = getValues().all_permission

    permissionsRoles.map((item, idx) => {
      if ('creatable' in item) setValue(`permissions[${idx}].creatable`, !allPermission)
      if ('readable' in item) setValue(`permissions[${idx}].readable`, !allPermission)
      if ('updatable' in item) setValue(`permissions[${idx}].updatable`, !allPermission)
      if ('deletable' in item) setValue(`permissions[${idx}].deletable`, !allPermission)
      if ('exportable' in item) setValue(`permissions[${idx}].exportable`, !allPermission)
      if ('approvable' in item) setValue(`permissions[${idx}].approvable`, !allPermission)
    })
  }, [getValues, setValue])

  return (
    <BooleanInput
      source='all_permission'
      label={`${ROLES_FIELDS}.all_permission`}
      onChange={toggleCheckAll}
      defaultValue={defaultValue}
    />
  )
}
